<template>
  <div class="undo-summary">
    <ul>
      <li>Se intentará revertir invitados creados y actualizados de esta importación.</li>
      <li>No se revertirán invitados con actividad posterior o conflictos de datos.</li>
      <li>El resultado puede ser total o parcial según reglas de seguridad.</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'UndoImportSummary'
}
</script>

<style scoped>
.undo-summary {
  background: #f6f8fa;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  padding: 12px;
}

.undo-summary ul {
  margin: 0;
  padding-left: 20px;
}
</style>
